export const DEFAULT_REPORTS_LOCALE = 'en-US';

export const supportedReportsLocales: Record<string, string> = {
  // English locales
  en: 'en-US',
  'en-US': 'en-US',
  'en-GB': 'en-GB',

  // Non-EU additional locales
  tr: 'tr',
  'tr-TR': 'tr',
  he: 'he',
  'he-IL': 'he',
  sr: 'sr',
  'sr-RS': 'sr',

  ja: 'ja',
  'ja-JP': 'ja',

  // 24 Core EU Languages (27 EU Member States)
  bg: 'bg',
  'bg-BG': 'bg',
  cs: 'cs',
  'cs-CZ': 'cs',
  cz: 'cs', // Alias for 'cz' specified in the ticket
  da: 'da',
  'da-DK': 'da',
  de: 'de',
  'de-DE': 'de',
  el: 'el',
  'el-GR': 'el',
  es: 'es',
  'es-ES': 'es',
  et: 'et',
  'et-EE': 'et',
  fi: 'fi',
  'fi-FI': 'fi',
  fr: 'fr',
  'fr-FR': 'fr',
  ga: 'ga',
  'ga-IE': 'ga',
  hr: 'hr',
  'hr-HR': 'hr',
  hu: 'hu',
  'hu-HU': 'hu',
  it: 'it',
  'it-IT': 'it',
  lt: 'lt',
  'lt-LT': 'lt',
  lv: 'lv',
  'lv-LV': 'lv',
  lb: 'lb',
  'lb-LU': 'lb',
  mt: 'mt',
  'mt-MT': 'mt',
  nl: 'nl',
  'nl-NL': 'nl',
  pl: 'pl',
  'pl-PL': 'pl',
  pt: 'pt',
  'pt-PT': 'pt',
  ro: 'ro',
  'ro-RO': 'ro',
  sk: 'sk',
  'sk-SK': 'sk',
  sl: 'sl',
  'sl-SI': 'sl',
  sv: 'sv',
  'sv-SE': 'sv',
};

export const resolveReportsLocale = (
  locale: string | null | undefined
): string => {
  const normalizedLocale = locale?.trim().replaceAll('_', '-');

  if (!normalizedLocale) {
    return DEFAULT_REPORTS_LOCALE;
  }

  const exactLocale = supportedReportsLocales[normalizedLocale];

  if (exactLocale) {
    return exactLocale;
  }

  const [language = ''] = normalizedLocale.split('-');
  const languageLocale = supportedReportsLocales[language];

  return languageLocale ?? DEFAULT_REPORTS_LOCALE;
};

export const getBrowserLocale = (): string => {
  if (typeof navigator === 'undefined') {
    return DEFAULT_REPORTS_LOCALE;
  }

  const languages = navigator.languages?.length
    ? navigator.languages
    : [navigator.language || DEFAULT_REPORTS_LOCALE];

  for (const locale of languages) {
    if (typeof locale !== 'string' || locale.trim() === '') {
      continue;
    }

    const resolved = resolveReportsLocale(locale);
    const normalized = locale.trim().replaceAll('_', '-');
    const baseLocale = normalized.split('-')[0] || '';

    const isSupported =
      Boolean(supportedReportsLocales[normalized]) ||
      Boolean(supportedReportsLocales[baseLocale]);

    if (isSupported) {
      return resolved;
    }
  }

  return resolveReportsLocale(navigator.language || DEFAULT_REPORTS_LOCALE);
};
